import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { auth } from "../../../../config/firebaseConfig";
import { individualRegisterFormFields } from "../../constants/individualRegisterFormFields";
import { Button, TextInput, SelectInput } from "../../../../components";
// import envConfig from "../../../../config/envConfig";
import { validateEmail, validatePhone } from "../../../../assets/js/validation";
import { parentRegisterSuccess } from "../../../../constant/emailTemplates/parentRegisterSuccess";
import SchoolDetails from "../components/SchoolDetails";
// import authService from "../../../../firebase/authService";
import { useDispatch } from "react-redux";
import { register } from "../../../../redux/features/authSlice";
import { GAEventTrack } from "../../../../utils/hooks/GA_events";
import dbService from "../../../../firebase/dbService";
// import VerifMailSentModule from "../components/VerifMailSentModule";
import { sendEmailHandler } from "../../../../utils/helperFunctions/sendEmailHandler";
import authServiceMobile from "../../../../firebase/authServiceMobile";
import dbServiceMobile from "../../../../firebase/dbServiceMobile";
import AppStoreButtons from "../../../../components/AppStoreButtons";
import { RxCross2 } from "react-icons/rx";
import { parentRegisterViaSchoolLinkSuccess } from "../../../../constant/emailTemplates/parentRegisterViaSchoolLinkSuccess";

const IndividualRegisterForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);
  // const { setShowTabs } = useOutletContext();
  const { schoolId } = useParams();
  const [schoolDetails, setSchoolDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [emailId, setEmailId] = useState("");
  const [showVerifMailSentModule] = useState(false);

  // Local state for select inputs
  const [selectedClassOption, setSelectedClassOption] = useState(null);

  // State for handling existing mobile account flow
  const [showMobileLoginModal, setShowMobileLoginModal] = useState(false);
  const [mobileLoginPassword, setMobileLoginPassword] = useState("");
  const [mobileLoginError, setMobileLoginError] = useState("");
  const [mobileLoginLoading, setMobileLoginLoading] = useState(false);
  const [pendingRegData, setPendingRegData] = useState(null);

  // useEffect(() => {
  //   if (schoolId || showVerifMailSentModule) {
  //     setShowTabs(false);
  //   } else {
  //     setShowTabs(true);
  //   }
  // }, [setShowTabs, schoolId, showVerifMailSentModule]);

  useEffect(() => {
    const fetchSchoolDetails = async () => {
      try {
        const data = await dbService.getdocument("schools", schoolId);
        if (data) {
          setSchoolDetails(data);
        } else {
          console.log("invalid school id");
          //todo: show this to user as a warning
        }
      } catch (error) {
        console.log(error);
      }
    };

    schoolId && fetchSchoolDetails();
  }, [schoolId]);

  const createAuthWithEmailAndPass = async ({
    name,
    email,
    phone,
    password,
    docId,
  }) => {
    console.log("start registration - web");
    try {
      const parentData = {
        accountType: "parent",
        email,
        name,
        phone,
      };
      schoolDetails && (parentData.schoolId = schoolId);

      // unwrap to throw on rejection from thunk
      await dispatch(
        register({ email, password, name, docId, data: parentData })
      ).unwrap();

      GAEventTrack({
        event: "ind_reg_auth_added",
        data: { uid: auth?.currentUser?.uid, userEmail: email },
      });
      console.log("end registration - web");
    } catch (error) {
      console.log("error registration - web", error);
      throw new Error(error);
    }
  };

  const createMobileAuth = async ({ name, email, password, studentClass }) => {
    console.log("start registration - mobile");
    try {
      const user = await authServiceMobile.createAccount({
        email,
        password,
        name,
      });

      const mobileUid = user?.uid;

      const mobileDocData = {
        parent_email: email,
        name,
        avatar: "1",
        class: Number(studentClass),
        subject_name: "Maths",
      };

      const created = await dbServiceMobile.createDocumentWithId(
        "user",
        mobileDocData,
        mobileUid
      );
      if (!created) {
        // Firestore write failed, rollback the mobile auth user
        try {
          await authServiceMobile.deleteGivenUser(user);
        } catch (_) {}
        throw new Error("Failed to save mobile profile. Please try again.");
      }

      GAEventTrack({
        event: "ind_mobile_auth_doc_created",
        data: { email, mobileUid },
      });

      console.log("end registration - mobile");
      return { mobileUid, mobileUser: user, mobileDocCreated: true };
    } catch (error) {
      console.log("error registration - mobile", error);
      GAEventTrack({ event: "ind_mobile_auth_doc_failed", data: { email } });
      // Re-throw original Firebase error so caller can branch on error.code
      throw error;
    }
  };

  // const sendVerifEmail = async () => {
  //   const actionSettings = {
  //     url: `${envConfig?.appUrl}onboarding/step1`,
  //     handleCodeInApp: true,
  //   };
  //   try {
  //     await authService.sendVerificationEmail(actionSettings);
  //     //GA event tracking
  //     GAEventTrack({
  //       event: "ind_verif_email_sent",
  //       data: { email: auth?.currentUser?.email, uid: auth?.currentUser?.uid },
  //     });
  //   } catch (error) {
  //     console.log(error);
  //     throw new Error(error);
  //   }
  // };

  // const resendVerifEmail = async () => {
  //   try {
  //     setLoading(true);
  //     await sendVerifEmail();
  //   } catch (error) {
  //     console.log(error);
  //     setError((prev) => ({ ...prev, resend: error.message }));
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const resetFieldError = (field) => {
    setError((prev) => ({ ...prev, [field]: null }));
  };

  const validateForm = (name, email, phone, password, studentClass) => {
    const errors = {};

    // Required field validations
    if (!name) {
      errors.name = "Name is required.";
    }
    if (!email) {
      errors.email = "Email is required.";
    }
    if (!phone) {
      errors.phone = "Phone No. is required.";
    }
    if (!password) {
      errors.password = "Password is required.";
    }
    if (!studentClass) {
      errors.class = "Class is required.";
    }

    // Format validations (only if field is not empty)
    if (email && !validateEmail(email)) {
      errors.email = "Please enter a valid email id.";
    }
    if (phone && !validatePhone(phone)) {
      errors.phone = "Please enter a valid 10 digit phone number.";
    }
    if (password && password.length < 6) {
      errors.password = "Password should be atleast 6 characters long.";
    }
    if (studentClass && isNaN(Number(studentClass))) {
      errors.class = "Please select a valid class (number).";
    }

    return errors;
  };

  const sendSuccessMail = async (name, email) => {
    const emailTemplateFunction = schoolDetails
      ? parentRegisterViaSchoolLinkSuccess
      : parentRegisterSuccess;
    const { subject, emailBody } = emailTemplateFunction({
      parentName: name,
      parentEmail: email,
      schoolName: schoolDetails?.schoolName || "",
      fee: schoolDetails?.fee?.total || 99,
    });

    await sendEmailHandler({
      emailId: email,
      subject,
      body: emailBody,
    });

    GAEventTrack({
      event: "ind_success_email_sent",
      data: {
        uid: auth?.currentUser?.uid,
        userEmail: email,
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const formData = e.target;

    // Extract form values once
    const name = formData?.name?.value?.trim();
    const email = formData?.email?.value?.trim();
    const phone = formData?.phone?.value?.trim();
    const password = formData?.password?.value?.trim();
    const studentClass = selectedClassOption?.value;

    // Validate form
    const validationErrors = validateForm(
      name,
      email,
      phone,
      password,
      studentClass
    );

    // If there are validation errors, show them and focus on first error field
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      // Focus on the first field with error
      const firstErrorField = Object.keys(validationErrors)[0];
      if (firstErrorField === "class") {
        // For class field, we can't focus on select, so focus on email as fallback
        formData.email.focus();
      } else {
        formData[firstErrorField]?.focus();
      }
      return;
    }

    // GA event tracking
    GAEventTrack({
      event: "ind_register_submit",
    });

    const docId = `${name.split(" ")[0]?.toLowerCase()}_${phone?.slice(
      -4
    )}_${Math.random().toString(36).slice(-4)}`;

    setLoading(true);
    let mobileUid;
    let mobileUser;
    let mobileDocCreated = false;

    // Step 1: Create Mobile auth + document
    try {
      const mobileCreateRes = await createMobileAuth({
        name,
        email,
        password,
        studentClass,
      });
      mobileUid = mobileCreateRes?.mobileUid;
      mobileUser = mobileCreateRes?.mobileUser;
      mobileDocCreated = !!mobileCreateRes?.mobileDocCreated;
    } catch (error) {
      console.log(error);
      const isEmailInUse = error?.code === "auth/email-already-in-use";
      if (isEmailInUse) {
        // Prompt for mobile login; continue flow after successful login
        setPendingRegData({ name, email, phone, docId });
        setShowMobileLoginModal(true);
        setLoading(false);
        return;
      }
      const message =
        typeof error === "string"
          ? error
          : error?.message || "Registration failed. Please try again.";
      setError((prev) => ({ ...prev, other: message }));
      setLoading(false);
      return;
    }

    // Step 2: Create Web auth + Firestore
    try {
      await createAuthWithEmailAndPass({ name, email, phone, password, docId });

      // 2. send verification mail to user
      // await sendVerifEmail();

      // 3. show verification email sent
      // setShowVerifMailSentModule(true);

      // 4. send success email
      await sendSuccessMail(name, email);
      navigate("/parentDashboard");
    } catch (error) {
      console.log(error);
      // Rollback mobile account since web creation failed after mobile succeeded
      if (mobileUid) {
        try {
          if (mobileDocCreated) {
            await dbServiceMobile.deleteDocument("user", mobileUid);
          }
        } catch (_) {}
        try {
          if (mobileUser) {
            await authServiceMobile.deleteGivenUser(mobileUser);
          }
        } catch (_) {}
        GAEventTrack({
          event: "ind_mobile_rollback_success",
          data: { email, mobileUid },
        });
      }
      const message =
        typeof error === "string"
          ? error
          : error?.message || "Registration failed. Please try again.";
      setError((prev) => ({ ...prev, other: message }));
    } finally {
      setLoading(false);
    }
  };

  const handleMobileLoginConfirm = async () => {
    if (!pendingRegData) return;
    setMobileLoginError("");
    setMobileLoginLoading(true);
    try {
      await authServiceMobile.login({
        email: pendingRegData.email,
        password: mobileLoginPassword,
      });

      // Proceed with web auth using the same password entered in modal
      await createAuthWithEmailAndPass({
        name: pendingRegData.name,
        email: pendingRegData.email,
        phone: pendingRegData.phone,
        password: mobileLoginPassword,
        docId: pendingRegData.docId,
      });

      // success -> close modal and reset state
      setShowMobileLoginModal(false);
      setMobileLoginPassword("");
      setPendingRegData(null);

      navigate("/parentDashboard");
    } catch (err) {
      // Show error in modal to allow retry
      const msg = err?.message || "Login failed. Please try again.";
      setMobileLoginError(msg);
    } finally {
      setMobileLoginLoading(false);
    }
  };

  const handleMobileLoginCancel = () => {
    setShowMobileLoginModal(false);
    setMobileLoginPassword("");
    setMobileLoginError("");
  };

  return (
    <>
      {schoolDetails && <SchoolDetails details={schoolDetails} />}
      <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 mb-4 mt-6 sm:mt-2 lg:mt-6">
        New to Practido - Olympiad Practice?
      </h3>
      {schoolDetails && (
        <div className="bg-blue-50 border-l-4 rounded-lg border-blue-400 p-3 sm:p-4 rounded-r-lg mb-4">
          <h4 className="text-blue-800 font-semibold text-sm sm:text-base mb-1">
            Special Offer for {schoolDetails?.schoolName || ""}
            Students!
          </h4>
          <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">
            Practice unlimited questions in Math, Science, Computers & English
            (Classes 1-8)
            <br />
            <strong>Special Academic Year Offer:</strong> One-time fee of ₹
            {schoolDetails?.fee.total} per student (valid for this academic
            year) on Practido - Olympiad Practice App.
          </p>
        </div>
      )}
      {showVerifMailSentModule ? (
        ""
      ) : (
        // <VerifMailSentModule
        //   emailId={emailId}
        //   resendVerifEmail={resendVerifEmail}
        //   setShowVerifMailSentModule={setShowVerifMailSentModule}
        //   error={error}
        //   loading={loading}
        // />
        <form
          onSubmit={handleSubmit}
          className="wid-100"
          ref={formRef}
          noValidate
        >
          <div className="form-outer-container">
            {individualRegisterFormFields?.map(
              ({
                name,
                label,
                type,
                required,
                placeholder,
                colSpan,
                selectOptions,
              }) => {
                return (
                  <div key={name} className={`form-group col-span-${colSpan}`}>
                    <label htmlFor={name}>
                      {label}
                      {required && <span> * </span>}
                    </label>
                    {type === "select" ? (
                      <SelectInput
                        placeholderText={placeholder}
                        selectOptions={selectOptions}
                        inputName={name}
                        value={
                          name === "class" ? selectedClassOption : undefined
                        }
                        isClearable={true}
                        error={error?.[name]}
                        handleChange={(option) => {
                          if (name === "class") {
                            resetFieldError("class");
                            setSelectedClassOption(option);
                          }
                        }}
                      />
                    ) : (
                      <>
                        <TextInput
                          type={type}
                          placeholderText={placeholder}
                          inputName={name}
                          isRequired={required}
                          error={error?.[name]}
                          handleChange={() => resetFieldError(name)}
                        />
                      </>
                    )}
                  </div>
                );
              }
            )}
          </div>
          <div className="flex flex-col gap-4 mt-5 col-md-12">
            <div className="">
              {error?.other && (
                <div className="text-[#f00] text-xs mb-1">{error?.other}</div>
              )}
              <Button
                version="secondary"
                text="Submit"
                type="submit"
                loading={loading}
              />
            </div>
            <div className="text-lg flex gap-2">
              <p className="font-medium">Already Have an Account?</p>
              <Link
                to="/login/individual"
                className="font-bold hover:underline cursor-pointer text-[#009DFF] hover:text-[#009DFF]"
                onClick={() => {
                  //GA event tracking
                  GAEventTrack({
                    event: "signin_btn_ind",
                  });
                }}
              >
                Sign In
              </Link>
            </div>
          </div>
        </form>
      )}
      {showMobileLoginModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
          <div className="relative w-full max-w-sm rounded-xl bg-white p-5 shadow-xl">
            <div
              onClick={handleMobileLoginCancel}
              className="cursor-pointer absolute top-5 right-5 flex items-center justify-center h-8 w-8 bg-gray-200 rounded-full"
            >
              <RxCross2 className="w-5 h-5" />
            </div>
            <h4 className="text-lg font-bold text-gray-800 mb-2">
              Your account already exists on Practido Mobile App
            </h4>
            <p className="text-xs sm:text-sm text-gray-700 mb-3">
              Sign in with your password to continue.
            </p>
            <div className="mb-3">
              <label className="block text-xs font-medium text-gray-600 mb-1">
                Email
              </label>
              <div className="text-sm font-semibold text-gray-900 break-all">
                {pendingRegData?.email}
              </div>
            </div>
            <div className="mb-2">
              <label className="block text-xs font-medium text-gray-600 mb-1">
                Password
              </label>
              <TextInput
                type="password"
                placeholderText="Enter your password"
                inputName="login-password"
                isRequired={true}
                handleChange={(e) => setMobileLoginPassword(e.target.value)}
              />
            </div>
            {mobileLoginError && (
              <div className="text-[#f00] text-xs mb-2">{mobileLoginError}</div>
            )}
            <div className="mt-3 flex items-center gap-2 justify-center">
              <Button
                version="secondary"
                text={mobileLoginLoading ? "Signing In..." : "Sign In"}
                type="button"
                loading={mobileLoginLoading}
                isDisabled={!mobileLoginPassword || mobileLoginLoading}
                handleClick={handleMobileLoginConfirm}
              />
            </div>
          </div>
        </div>
      )}
      <div className="mt-8 space-y-4">
        <div className="mt-4 space-y-2">
          <h4 className="text-gray-800 text-base sm:text-lg font-bold">
            Download Practido - Olympiad Practice App
          </h4>
          <p className="text-gray-600 text-xs sm:text-sm">
            10,000+ installs, Teacher Approved by Google, and a 4.5★ Play Store
            and App Store rating
          </p>
          <ul className="list-disc pl-5 text-gray-700 text-xs sm:text-sm space-y-1">
            <li>
              Unlimited practice in Math, Science, Computers & English (Class
              1–8)
            </li>
            <li>
              Gamified challenges – trophies, leaderboard, points & rewards
            </li>
            <li>
              Challenge your friends – make Olympiad practice exciting and fun
            </li>
            <li>Instant results & progress tracking</li>
            <li>
              Check solutions for every question – learn from mistakes instantly
            </li>
            <li>Anytime, anywhere learning without extra workload</li>
            <li>
              No waiting for the next book, no running out of material – just
              practice & improvement
            </li>
          </ul>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-2">
            <AppStoreButtons />
          </div>
        </div>
      </div>
    </>
  );
};

export default IndividualRegisterForm;
